import ScalarCheckboxRadioGroup_vue_vue_type_script_setup_true_lang_default from "./ScalarCheckboxRadioGroup.vue.script.js";
//#region src/components/ScalarCheckboxInput/ScalarCheckboxRadioGroup.vue
var ScalarCheckboxRadioGroup_default = ScalarCheckboxRadioGroup_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarCheckboxRadioGroup_default as default };

//# sourceMappingURL=ScalarCheckboxRadioGroup.vue.js.map